import { link } from "@/components/Action.tsx";
import type { BillingAccountWithType } from "@/modules/billing/billingAccountQuery.ts";
import type { EBillingAccount } from "@/modules/billing/billingLogic.tsx";
import type { BillingAccountInvoice } from "@warrenio/api-spec/spec.oats.gen";

export function makeInvoiceLink(
    { id, type }: BillingAccountInvoice,
    { id: baId }: BillingAccountWithType | EBillingAccount,
) {
    return link({
        to: "/billing/account/$id/detail/$type/$invoiceId",
        params: { id: String(baId), type, invoiceId: String(id) },
    });
}
